import React from "react";
import theme from "../../../../../Styles/theme";
import Modal from "react-modal";
import { Button, Container } from "./styles";
import { Edit2, Trash2 } from "react-feather";
import { ModalDivX } from "../../../../ModalDivX"; 

const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      backgroundColor: theme.colors.secondary,

      borderRadius: "0.25rem",
    },
  };
  
  interface Props {
    open: boolean;
    onClose(): void;
    confirmOperation():void;
    cencelOperation():void;
  }
  

export function DefineOperationModal({open, onClose, confirmOperation, cencelOperation}:Props){

    return(

        <Modal isOpen={open} onRequestClose={onClose} style={customStyles}>
            <ModalDivX execute={onClose}/>
            <Container>
                <Button onClick={cencelOperation}>
                    Excluir<Trash2 size={"max(1.4vw, 14px)"}/>
                </Button>
                <Button onClick={confirmOperation}>
                    Editar<Edit2 size={"max(1.4vw, 14px)"}/>
                </Button>
            </Container>
        </Modal>

    );

    

}